import { ApplicationInsights, Snippet } from "@microsoft/applicationinsights-web";

// This is a method instead of a value so that we can mock the connectionString
// in unit tests more easily
const _getConfig = (): Snippet => {
  return {
    config: {
      connectionString: process.env.APP_INSIGHTS_CONNECTION_STRING,
      autoTrackPageVisitTime: true,
      enableUnhandledPromiseRejectionTracking: true,
      enableAjaxPerfTracking: true,
      enableAjaxErrorStatusText: true,
      enableResponseHeaderTracking: true,
    }
  };
};

const _createAndInitializeAppInsights = (): ApplicationInsights | null => {
  const config: Snippet = _getConfig();
  if (!config.config?.connectionString ) {
    console.log("Skipping app insights initialization, missing connection string")
    return null;
  }

  const appInsights: ApplicationInsights = new ApplicationInsights(config);
  appInsights.loadAppInsights();
  return appInsights;
}

/**
 * If shared AppInsights object is already created, then it will return the instance
 * currently stored on the window object. If not created yet, then it creates a new one,
 * stores it on the window object, and returns it.
 * @returns Shared AppInsights instance
 */
const getSharedAppInsights = (): ApplicationInsights | null => {
  try {
    return _createAndInitializeAppInsights();
  } catch (e) {
    console.warn("[Analytics] Failed to initialize AppInsights!", e);

    // We don't want to fail to load the page due to app insights errors, so return
    // null and we'll make sure the logging code handles null case
    return null;
  }
};

export { getSharedAppInsights };
